class $3c7c937469fabd57$export$e60daad661aebae6 {
    constructor(compute){
        this.compute = compute;
    }
    static{
        this.linear = new $3c7c937469fabd57$export$e60daad661aebae6((p)=>p);
    }
    static{
        this.cubic = new $3c7c937469fabd57$export$e60daad661aebae6((progress)=>{
            if (progress < 0.5) return 4 * progress * progress * progress;
            else {
                const p = 2 * progress - 2;
                return 0.5 * p * p * p + 1;
            }
        });
    }
    eval(progress) {
        return this.compute(progress);
    }
}
class $3c7c937469fabd57$export$deefd61317ad2797 {
    constructor(duration, onUpdate){
        this.duration = 0;
        this.start = 0;
        this.time = 0;
        this.curve = $3c7c937469fabd57$export$e60daad661aebae6.linear;
        this.duration = duration;
        this.updateCallback = onUpdate;
    }
    update(dt) {
        if (this.time < this.start) {
            this.time += dt;
            if (this.time > this.start) this.updateCallback(0, dt);
        } else if (this.time <= this.start + this.duration) {
            this.updateCallback(this.computeProgress(), dt);
            this.time += dt;
            if (this.time > this.start + this.duration) this.updateCallback(1, dt);
        }
    }
    ease(curve) {
        this.curve = curve;
        return this;
    }
    get end() {
        return this.start + this.duration;
    }
    get isCompleted() {
        return this.time >= this.end;
    }
    computeProgress() {
        if (this.duration === 0) return 1;
        const sinceStart = Math.max(0, this.time - this.start);
        return this.curve.eval(Math.min(1, sinceStart / this.duration));
    }
    static sequence(...children) {
        let duration = 0;
        for (const child of children){
            child.start = duration;
            duration += child.duration;
        }
        return new $3c7c937469fabd57$export$deefd61317ad2797(duration, (_, dt)=>{
            for (const child of children)child.update(dt);
        });
    }
    static parallel(...children) {
        let duration = 0;
        for (const child of children)duration = Math.max(duration, child.duration + child.start);
        return new $3c7c937469fabd57$export$deefd61317ad2797(duration, (_, dt)=>{
            for (const child of children)child.update(dt);
        });
    }
    static instant(callback) {
        return new $3c7c937469fabd57$export$deefd61317ad2797(0, callback);
    }
    static linear(duration, callback) {
        return new $3c7c937469fabd57$export$deefd61317ad2797(duration, callback);
    }
    static sleep(duration) {
        return new $3c7c937469fabd57$export$deefd61317ad2797(duration, ()=>{});
    }
    static ease(duration, ease, callback) {
        return new $3c7c937469fabd57$export$deefd61317ad2797(duration, callback).ease(ease);
    }
    static loop(factory) {
        const player = new $3c7c937469fabd57$export$58a7a7c7ac06cf9c(()=>player.play(factory()));
        player.play(factory());
    }
}
class $3c7c937469fabd57$export$58a7a7c7ac06cf9c {
    constructor(onComplete = null){
        this.anim = null;
        this.last = performance.now();
        this.onComplete = null;
        this.onComplete = onComplete;
        this.requestFrame();
    }
    requestFrame() {
        requestAnimationFrame((time)=>this.processFrame(time));
    }
    processFrame(time) {
        if (this.anim) {
            this.anim.update(performance.now() - this.last);
            if (this.anim.isCompleted) {
                this.anim = null;
                this.onComplete?.();
            }
        }
        this.last = time;
        this.requestFrame();
    }
    play(anim) {
        this.anim = anim;
    }
}
function $3c7c937469fabd57$export$3a89f8d6f6bf6c9f(a, b, progress) {
    return a + (b - a) * progress;
}


class $f9111b9a59993cf8$var$InfiniteScroller {
    constructor(parent, options){
        this.parent = parent;
        this.options = options;
        this.elements = [];
        this.elementOffsets = [];
        this.scrollPosition = 0;
        parent.childNodes.forEach((child)=>{
            const el = child;
            this.elements.push(el);
            this.elementOffsets.push(0);
        });
        this.gap = this.computeGap();
    }
    scroll(dist) {
        const parentRect = this.parent.getBoundingClientRect();
        const parentStart = this.getStart(parentRect);
        this.scrollPosition += dist;
        for(let index = 0; index < this.elements.length; index++)this.moveElement(index, dist);
        const sortedElements = this.getSortedElements();
        let maxEnd = this.getEnd(sortedElements[sortedElements.length - 1].rect);
        for (const se of sortedElements)if (this.getEnd(se.rect) < parentStart) {
            const start = this.getStart(se.rect);
            const end = this.getEnd(se.rect);
            this.moveElement(se.index, maxEnd - start + this.gap);
            maxEnd += end - start;
        }
    }
    getSortedElements() {
        const result = this.elements.map((element, index)=>{
            const rect = element.getBoundingClientRect();
            return {
                index: index,
                element: element,
                rect: rect
            };
        });
        return result.sort((a, b)=>this.getStart(a.rect) - this.getStart(b.rect));
    }
    scrollTo(position) {
        const dist = position - this.scrollPosition;
        this.scroll(dist);
    }
    reset() {
        this.scrollPosition = 0;
        this.gap = this.computeGap();
        this.elements.forEach((_, index)=>{
            this.moveElement(index, -this.elementOffsets[index]);
        });
    }
    computeLoopDistance() {
        const parentRect = this.parent.getBoundingClientRect();
        const parentStart = this.getStart(parentRect);
        const max = this.computeMaxEnd();
        return max - parentStart + this.gap;
    }
    get isHorizontal() {
        return this.options.axis === "x";
    }
    computeMaxEnd() {
        let max = 0;
        for (const element of this.elements){
            const rect = element.getBoundingClientRect();
            const end = this.getEnd(rect);
            if (end > max) max = end;
        }
        return max;
    }
    computeGap() {
        if (!this.elements.length) return 0;
        const firstRect = this.elements[0].getBoundingClientRect();
        const secondRect = this.elements[1].getBoundingClientRect();
        return this.getStart(secondRect) - this.getEnd(firstRect);
    }
    getStart(rect) {
        if (this.isHorizontal) return rect.left;
        else return rect.top;
    }
    getEnd(rect) {
        if (this.isHorizontal) return rect.right;
        else return rect.bottom;
    }
    moveElement(index, dist) {
        this.elementOffsets[index] += dist;
        const offset = this.elementOffsets[index];
        if (this.isHorizontal) this.elements[index].style.transform = `translateX(${offset}px)`;
        else this.elements[index].style.transform = `translateY(${offset}px)`;
    }
}
class $f9111b9a59993cf8$export$6261950c44b1b41 {
    constructor(parent, options){
        this.options = options;
        this.scroller = new $f9111b9a59993cf8$var$InfiniteScroller(parent, {
            axis: "x"
        });
        this.start();
    }
    start() {
        this.animate((dt)=>{
            if (dt > 100) this.scroller.reset();
            else this.scroller.scroll(-dt * this.options.speed);
        });
    }
    animate(callback) {
        let last = -1;
        function cb(timestamp) {
            if (last > 0) callback(timestamp - last);
            last = timestamp;
            requestAnimationFrame(cb);
        }
        requestAnimationFrame(cb);
    }
}


const $fcbf1798b76ddfa3$var$WINDOW_PADDING_X = 0.01;
const $fcbf1798b76ddfa3$var$WINDOW_PADDING_Y = $fcbf1798b76ddfa3$var$WINDOW_PADDING_X * 1.6;
const $fcbf1798b76ddfa3$var$CLASSES = {
    pressed: "pressed",
    selected: "selected",
    smBar: "sm-bar"
};
class $fcbf1798b76ddfa3$var$Window {
    constructor(element = null){
        this.state = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            opacity: 0
        };
        if (element) this.element = element;
        else {
            this.element = element ?? document.createElement("div");
            this.element.classList.add("window-area");
        }
    }
    appendTo(parent) {
        parent.appendChild(this.element);
    }
    setState(state) {
        this.state = state;
        const area = $fcbf1798b76ddfa3$var$Window.padArea(state);
        this.element.style.left = `${area.left * 100}%`;
        this.element.style.right = `${area.right * 100}%`;
        this.element.style.top = `${area.top * 100}%`;
        this.element.style.bottom = `${area.bottom * 100}%`;
        this.element.style.widows = "";
        this.element.style.height = "";
        this.element.style.opacity = `${state.opacity}`;
    }
    getState() {
        return this.state;
    }
    lerp(from, to) {
        return (p)=>{
            this.setState({
                left: (0, $3c7c937469fabd57$export$3a89f8d6f6bf6c9f)(from.left, to.left, p),
                top: (0, $3c7c937469fabd57$export$3a89f8d6f6bf6c9f)(from.top, to.top, p),
                right: (0, $3c7c937469fabd57$export$3a89f8d6f6bf6c9f)(from.right, to.right, p),
                bottom: (0, $3c7c937469fabd57$export$3a89f8d6f6bf6c9f)(from.bottom, to.bottom, p),
                opacity: (0, $3c7c937469fabd57$export$3a89f8d6f6bf6c9f)(from.opacity, to.opacity, p)
            });
        };
    }
    center() {
        const domRect = this.element.getBoundingClientRect();
        const parentDomRect = this.element.parentElement.getBoundingClientRect();
        this.setPosition((parentDomRect.width - domRect.width) / 2, (parentDomRect.height - domRect.height) / 2);
    }
    setPosition(x, y) {
        this.element.style.left = `${x}px`;
        this.element.style.top = `${y}px`;
    }
    static getMouseEventPoint(event) {
        return {
            x: event.pageX,
            y: event.pageY
        };
    }
    static padArea(area) {
        const left = $fcbf1798b76ddfa3$var$Window.padValue(area.left, $fcbf1798b76ddfa3$var$WINDOW_PADDING_X);
        const right = $fcbf1798b76ddfa3$var$Window.padValue(area.right, $fcbf1798b76ddfa3$var$WINDOW_PADDING_X);
        const top = $fcbf1798b76ddfa3$var$Window.padValue(area.top, $fcbf1798b76ddfa3$var$WINDOW_PADDING_Y);
        const bottom = $fcbf1798b76ddfa3$var$Window.padValue(area.bottom, $fcbf1798b76ddfa3$var$WINDOW_PADDING_Y);
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    static padValue(value, padding) {
        return value === 0 ? padding : value + padding / 2;
    }
}
class $fcbf1798b76ddfa3$var$WindowManagerKeybinds {
    constructor(parent){
        this.autoRelease = true;
        this.windowStateIndex = 0;
        this.player = new (0, $3c7c937469fabd57$export$58a7a7c7ac06cf9c)();
        setInterval(()=>this.pressButton(), 1000);
        this.button = parent.querySelector("button");
        this.button.addEventListener("mousedown", ()=>this.pressButton(false));
        this.button.addEventListener("mouseup", ()=>this.releaseButton(true));
        this.windowStateLabels = [
            "1 / 2",
            "1 / 3",
            "1 / 4"
        ];
        this.windowStates = [
            {
                top: 0,
                bottom: 0,
                left: 0.5,
                right: 0,
                opacity: 1
            },
            {
                top: 0,
                bottom: 0,
                left: 2 / 3,
                right: 0,
                opacity: 1
            },
            {
                top: 0,
                bottom: 0,
                left: 3 / 4,
                right: 0,
                opacity: 1
            }
        ];
        this.window = new $fcbf1798b76ddfa3$var$Window(parent.querySelector(".window-area"));
        this.window.element.textContent = this.windowStateLabels[0];
        this.window.setState(this.windowStates[0]);
    }
    pressButton(autoRelease = null) {
        if (autoRelease !== null) this.autoRelease = autoRelease;
        this.button.classList.add($fcbf1798b76ddfa3$var$CLASSES.pressed);
        this.lerpToNextWindowState();
        if (this.autoRelease) setTimeout(()=>this.releaseButton(), 200);
    }
    releaseButton(autoRelease = null) {
        if (autoRelease !== null) this.autoRelease = autoRelease;
        if (this.autoRelease) this.button.classList.remove($fcbf1798b76ddfa3$var$CLASSES.pressed);
    }
    lerpToNextWindowState() {
        const nextIndex = (this.windowStateIndex + 1) % this.windowStates.length;
        this.player.play((0, $3c7c937469fabd57$export$deefd61317ad2797).sequence((0, $3c7c937469fabd57$export$deefd61317ad2797).instant(()=>{
            this.window.element.textContent = this.windowStateLabels[nextIndex];
        }), (0, $3c7c937469fabd57$export$deefd61317ad2797).ease(200, (0, $3c7c937469fabd57$export$e60daad661aebae6).cubic, this.window.lerp(this.window.getState(), this.windowStates[nextIndex]))));
        this.windowStateIndex = nextIndex;
    }
}
class $fcbf1798b76ddfa3$var$WindowManagerMonitorSetup {
    constructor(parent, states){
        for (const state of states){
            const window = new $fcbf1798b76ddfa3$var$Window();
            window.appendTo(parent);
            window.setState(state);
        }
    }
}
class $fcbf1798b76ddfa3$var$BarChart {
    constructor(parent){
        this.parent = parent;
        this.selectionDir = 1;
        this.populate();
        const observer = new ResizeObserver(()=>this.onResize());
        observer.observe(parent);
    }
    onResize() {
        this.populate();
        this.removeOldBars();
    }
    populate() {
        while(!this.isPopulated())this.addBar();
    }
    addNewBar() {
        this.addBar();
        this.removeOldBars();
    }
    moveSelection() {
        const iterate = ()=>{
            const selected = this.parent.querySelector(`.${$fcbf1798b76ddfa3$var$CLASSES.selected}`);
            if (!selected) {
                const firstChild = this.parent.firstElementChild;
                if (!firstChild) return;
                firstChild.classList.add($fcbf1798b76ddfa3$var$CLASSES.selected);
                return;
            }
            const forward = this.selectionDir > 0 ? selected.nextElementSibling : selected.previousElementSibling;
            const backgward = this.selectionDir > 0 ? selected.previousElementSibling : selected.nextElementSibling;
            if (forward) {
                selected.classList.remove($fcbf1798b76ddfa3$var$CLASSES.selected);
                forward.classList.add($fcbf1798b76ddfa3$var$CLASSES.selected);
            } else if (backgward) {
                this.selectionDir *= -1;
                iterate();
            }
        };
        iterate();
    }
    isPopulated() {
        const firstChild = this.parent.firstElementChild;
        if (!firstChild) return false;
        const parentRect = this.parent.getBoundingClientRect();
        const firstRect = firstChild.getBoundingClientRect();
        return firstRect.left <= parentRect.left + firstRect.width / 2;
    }
    addBar() {
        const bar = document.createElement("div");
        bar.classList.add($fcbf1798b76ddfa3$var$CLASSES.smBar);
        this.parent.append(bar);
        const userBar = document.createElement("div");
        userBar.style.height = `${$fcbf1798b76ddfa3$var$BarChart.smoothAverage() * 100}%`;
        bar.append(userBar);
        const systemBar = document.createElement("div");
        systemBar.style.height = `${$fcbf1798b76ddfa3$var$BarChart.smoothAverage() * 100}%`;
        userBar.append(systemBar);
    }
    removeOldBars() {
        const parentRect = this.parent.getBoundingClientRect();
        for(let index = 0; index < this.parent.childElementCount; index++){
            const bar = this.parent.children.item(index);
            const rect = bar.getBoundingClientRect();
            if (rect.right < parentRect.left || rect.right <= 0) bar.remove();
            else break;
        }
    }
    static smoothAverage(count = 10) {
        let sum = 0;
        for(let index = 0; index < count; index++)sum += Math.random();
        return sum / count;
    }
}
class $fcbf1798b76ddfa3$var$Slider {
    constructor(element, initialValue = 1, onChange){
        this.onChange = onChange;
        this.track = element.querySelector(".track");
        this.bar = element.querySelector(".bar");
        this.knob = element.querySelector(".knob");
        this.setValue(initialValue);
        this.knob.addEventListener("pointerdown", ()=>{
            const trackRect = this.track.getBoundingClientRect();
            const onTouchMove = (event)=>{
                event.preventDefault();
                event.stopPropagation();
            };
            const onMove = (event)=>{
                const value = Math.min(1, Math.max(0, (event.clientX - trackRect.x) / trackRect.width));
                this.setValue(value);
                event.preventDefault();
                event.stopPropagation();
            };
            const onUp = ()=>{
                document.removeEventListener("touchmove", onTouchMove);
                document.removeEventListener("pointermove", onMove);
                document.removeEventListener("pointerup", onUp);
            };
            document.addEventListener("touchmove", onTouchMove);
            document.addEventListener("pointermove", onMove);
            document.addEventListener("pointerup", onUp);
        });
    }
    setValue(value) {
        const progress = `${value * 100}%`;
        this.bar.style.width = progress;
        this.knob.style.left = progress;
        this.onChange(value);
    }
}
class $fcbf1798b76ddfa3$var$BrightnessControl {
    constructor(element){
        this.shade = element.querySelector(".shade");
        new $fcbf1798b76ddfa3$var$Slider(element, 1, (value)=>this.updateShade(value));
    }
    updateShade(value) {
        this.shade.style.opacity = `${(1 - value) * 0.8}`;
    }
}
class $fcbf1798b76ddfa3$var$SystemMonitoringShowcase {
    constructor(element){
        this.features = [
            {
                title: "Organized View",
                description: "Child processes are grouped under their logical parent, and usage is aggregated, to give you the complete picture.",
                timestamp: 0
            },
            {
                title: "Disk Clean",
                description: "Free up disk space with one click. OneMenu scans for large files, caches, and junk so you can reclaim storage fast.",
                timestamp: 10.75
            },
            {
                title: "System Stats",
                description: "Monitor temperature, per-core CPU utilization, GPU usage, memory, network, and disk activity from one compact dashboard.",
                timestamp: 25.25
            }
        ];
        this.index = 0;
        this.video = element.querySelector("video");
        this.title = element.querySelector("h3");
        this.description = element.querySelector("p");
        element.querySelector(".previous").addEventListener("click", ()=>this.select(this.index - 1));
        element.querySelector(".next").addEventListener("click", ()=>this.select(this.index + 1));
        this.video.addEventListener("timeupdate", ()=>this.syncToVideo());
    }
    select(index) {
        this.index = (index + this.features.length) % this.features.length;
        const feature = this.features[this.index];
        this.render(feature);
        this.video.currentTime = feature.timestamp;
        this.video.play();
    }
    syncToVideo() {
        let nextIndex = 0;
        for(let index = 1; index < this.features.length; index++){
            if (this.video.currentTime < this.features[index].timestamp) break;
            nextIndex = index;
        }
        if (nextIndex === this.index) return;
        this.index = nextIndex;
        this.render(this.features[this.index]);
    }
    render(feature) {
        this.title.textContent = feature.title;
        this.description.textContent = feature.description;
    }
}
new $fcbf1798b76ddfa3$var$WindowManagerKeybinds(document.querySelector("#window-manager-keybinds"));
new $fcbf1798b76ddfa3$var$WindowManagerMonitorSetup(document.querySelector("#monitor-setup .ultrawide-monitor"), [
    {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0.8,
        opacity: 1
    },
    {
        top: 0,
        bottom: 0,
        left: 0.2,
        right: 0.2,
        opacity: 1
    },
    {
        top: 0,
        bottom: 0,
        left: 0.8,
        right: 0,
        opacity: 1
    }
]);
new $fcbf1798b76ddfa3$var$WindowManagerMonitorSetup(document.querySelector("#monitor-setup .macbook-pro .workspace"), [
    {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0.5,
        opacity: 1
    },
    {
        top: 0,
        bottom: 0.5,
        left: 0.5,
        right: 0,
        opacity: 1
    },
    {
        top: 0.5,
        bottom: 0,
        left: 0.5,
        right: 0,
        opacity: 1
    }
]);
document.querySelectorAll(".horizontal-carousel").forEach((element)=>{
    new (0, $f9111b9a59993cf8$export$6261950c44b1b41)(element, {
        speed: 0.02
    });
});
new $fcbf1798b76ddfa3$var$BarChart(document.querySelector("#system-monitoring-intro .sm-bar-chart"));
new $fcbf1798b76ddfa3$var$SystemMonitoringShowcase(document.querySelector("#system-monitoring"));
new $fcbf1798b76ddfa3$var$BrightnessControl(document.querySelector("#brightness-control"));


//# sourceMappingURL=one-menu.36243b48.js.map
